/**
 * Normalizes quiz result payloads (live submit vs history API) into the shape
 * expected by QuizeResults.
 */

function resolveOptionText(options, optionKey) {
    if (optionKey == null || optionKey === "") return null;
    if (Array.isArray(options)) {
        const match = options.find((o) => o.id === optionKey);
        return match?.text ?? optionKey;
    }
    if (options && typeof options === "object") {
        return options[optionKey] ?? optionKey;
    }
    return optionKey;
}

/** After POST /api/knowledge-quiz/submit */
export function mapSubmitPayloadToQuizResults(submitPayload) {
    const ordered = [...(submitPayload?.questions || [])].sort(
        (a, b) => a.displayOrder - b.displayOrder
    );

    const results = ordered.map((q) => ({
        question: q.questionText,
        selectedOption: resolveOptionText(q.options, q.selectedOption),
        correctOption: resolveOptionText(q.options, q.correctOption),
        explanation: q.explanation ?? null,
        isCorrect: q.isCorrect,
        notAttempted: Boolean(q.notAnswered ?? q.selectedOption == null),
    }));

    return {
        results,
        serverScore: {
            scoreCorrect: submitPayload.scoreCorrect,
            scoreTotal: submitPayload.scoreTotal,
            percent: submitPayload.percent,
        },
        gradingByIndex: ordered.map((q) => q.isCorrect),
    };
}

/** After GET /api/knowledge-quiz/history/:id/details */
export function mapHistoryDetailsToQuizResults({ attempt, questions = [] }) {
    const ordered = [...questions].sort(
        (a, b) => a.displayOrder - b.displayOrder
    );

    const results = ordered.map((q) => ({
        question: q.stem,
        selectedOption: resolveOptionText(q.options, q.selectedOption),
        correctOption: resolveOptionText(q.options, q.correctOption),
        explanation: q.explanation ?? null,
        isCorrect: q.isCorrect,
        notAttempted: q.selectedOption == null,
    }));

    return {
        results,
        serverScore: {
            scoreCorrect: attempt?.scoreCorrect,
            scoreTotal: attempt?.scoreTotal,
            percent: attempt?.scorePercentage,
        },
        licenseLabel: attempt?.licenseCategory,
        questionCount: attempt?.scoreTotal,
        quizProfileCode: attempt?.quizProfileCode,
        licenseTypeId: attempt?.licenseTypeId ?? null,
        subLicenseTypeId: attempt?.subLicenseTypeId ?? null,
    };
}
